module.exports = __webpack_public_path__ + "static/media/BO.5b31762f.png";